import { render } from "./Overtime.vue?vue&type=template&id=2faa7728"
import script from "./Overtime.vue?vue&type=script&lang=js"
export * from "./Overtime.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__